fx.ns("models", class ThemeLayout extends fx.Model {

	constructor(data)
	{
		super(data);
	}
	

	get defaults()
	{
		return {
			page_id : 0,
        	bgcolor : "rgba(0,0,0,0)",
        	components : [],
			num_photos : 0,
			num_texts : 0,
			height : 0,
			width : 0,
			themeid : -1,
			visible : 0,
			thumb : "",
            target : ""
		}
	}

	get propertiesNotStorable()
    {
        return ["thumb", "id"];
    }
    
    /**
     * Basic layouts have themeid equal to -1
     */
    get isBasic()
    {
        return this.themeid == -1 && this.accountid == 0;
    }

    get sortedComponents()
    {
        return this.components.sort(this._componentsSort);
    }

    _componentsSort(a, b) 
    {  
        if (a.content_type == "slice-text")
            return 1;
        else
        if (b.content_type == "slice-text")
            return -1;

        if (a.isBackground && !b.isBackground)
            return -1;

        if (!a.isBackground && b.isBackground)
            return 1;

        if (a.isBackground && b.isBackground)
        {
            if (a.creation == "slice")
                return 1;
            else
            if (b.creation == "slice")
                return -1;
            else
                return 0;
        }

        if (a.isSliceText)
        {
            if (b.isBackground)
                return 1;
            else
                return -1;
        }

        if (a.level < b.level)
            return -1;

        if (a.level > b.level)
            return 1;

        return 0;
    }
	
	getBackground(side)
    {
        let bg;
        for(let i = 0; i < this.components.length; i++)
        {
            let component = this.components.getItemAt(i);
            if (!component._deleted && component.isBackground && (!side || component.creation == side))
            {
                bg = component;
                break;
            }
        }
        return bg;
    }

    getBackgrounds()
    {
        let bgs = [];
        for(let i = 0; i < this.components.length; i++)
        {
            let component = this.components.getItemAt(i);
            if (!component._deleted && component.isBackground)
                bgs.push(  component );
            
        }
        return bgs;
    }


    getStickers()
    {
        let stickers = [];
        for(let i = 0; i < this.components.length; i++)
        {
            let component = this.components.getItemAt(i);
            if (!component._deleted && component.isSticker)
                stickers.push(  component );
            
        }
        return stickers;
    }

    getPhotos()
    {
        let photos = [];
        for(let i = 0; i < this.components.length; i++)
        {
            let component = this.components.getItemAt(i);
            if (!component._deleted && component.isPhoto)
                photos.push(  component );
            
        }
        return photos;
    }

    duplicate()
    {
        let layout = new models.ThemeLayout(this.JSON);

       
        layout.components.removeAll();

        for (let i = 0; i < this.components.length; i++)
        {
            let json = this.components.getItemAt(i).JSON;
            json.theme_layout_id = layout.id;
            delete(json.id);
            delete(json.creation_element_id);
            layout.components.addItem( new models.ThemeLayoutComponent( json ) );
        }

        return layout;
    }



   // ------------------------- //
    saveLayoutThumb()
    {
        this.on("thumb-generated", this._onLayoutThumbReady, fx.service("LayoutThumbGenerator"));

        fx.service("LayoutThumbGenerator").generate(this);
    }

    _onLayoutThumbReady(event)
    {
        this.off("thumb-generated", this._onLayoutThumbReady, fx.service("LayoutThumbGenerator"));

        let thumb = event.detail.thumb;
        
        this.post("/app/layouts/", {
                                        action : "savethumbbacislayouts", 
                                        layoutid : this.id,
                                        thumb : thumb,
                                        width : this.width,
                                        height : this.height
                                    },  this._savedLayoutThumb );
    }

    _savedLayoutThumb(data)
    {
        if (data.error)
        {
            this.event("save-layout-error");
        }
        else
        {
            this.thumb = data.thumb;
            this.event("layout-thumb-saved");
        }
    }


});